import {createGlobalStyle} from "styled-components"


export const GlobalStyle = createGlobalStyle`
    * {
        padding: 0;
        border: 0;
        margin: 0;
        box-sizing: border-box;
    }
    body {
        background-color: #131313;
        color: white;
    }
`